import React from 'react';
import PropTypes from 'prop-types';

import { useApplicationState } from '@atlas/core';
import { MoneyInput } from '@atlas/ui';

import Field from 'common/Form/Field';

const MoneyField = ({ field, onBlur, onChange, onFocus }) => {
  const {
    active,
    amountIcon,
    autofocus,
    className,
    disabled,
    errors,
    label,
    name,
    placeholder,
    touched,
    uiTitleClassName,
    value,
  } = field;

  const { wallet } = useApplicationState();

  const error = touched && errors[0];
  const success = touched && !error;

  return (
    <Field options={field}>
      <MoneyInput
        active={active}
        amountIcon={amountIcon}
        autoFocus={autofocus}
        className={className}
        currency={wallet.currency}
        disabled={disabled}
        error={error}
        label={label}
        name={name}
        onBlur={onBlur}
        onChange={onChange}
        onFocus={onFocus}
        placeholder={placeholder}
        success={success}
        touched={touched}
        uiTitleClassName={uiTitleClassName}
        value={value}
      />
    </Field>
  );
};

MoneyField.propTypes = {
  field: PropTypes.shape({
    active: PropTypes.bool,
    amountIcon: PropTypes.string,
    autoFocus: PropTypes.bool,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    errors: PropTypes.arrayOf(PropTypes.object),
    label: PropTypes.string,
    name: PropTypes.string,
    placeholder: PropTypes.string,
    touched: PropTypes.bool,
    uiTitleClassName: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
};

export default MoneyField;
